interface Props {
  onSignIn: () => void;
}

export function Header({ onSignIn }: Props) {
  return (
    <header className="lp-header">
      <a className="lp-header__brand" href="/" aria-label="Orchestration Coach home">
        <span className="lp-header__brand-mark" aria-hidden="true">◌</span>
        <span className="lp-header__brand-name">Orchestration Coach</span>
      </a>
      <button className="btn btn--text lp-header__signin" onClick={onSignIn}>
        Sign in
      </button>
    </header>
  );
}
